import { createBusinessLogger } from '@/utils/logger/businessLogger';

// 个人中心/心愿单/优惠券 事件名称常量
export const PROFILE_EVENT_NAMES = {
  EDIT_PROFILE_SAVE_FAILURE: 'edit_profile_save_failure',
  LINK_OCHAMA_ACCOUNT: 'link_ochama_account',

  COUPON_USE_CLICK: 'coupon_use_click',

  WISHLIST_DELETE: 'wishlist_delete',
  WISHLIST_DELETE_FAIL: 'wishlist_delete_fail',
} as const;

// 导出类型定义，既可以当常量用也可以当类型用
export type ProfileEventNames = typeof PROFILE_EVENT_NAMES;

// 暂时不需要分类，之后有需要再添加
const categoryNames: string[] = [];

// Business Logger 实例 - 个人中心
export const profileBusinessLogger = createBusinessLogger<ProfileEventNames>(
  'profile',
  categoryNames,
);

// Business Logger 实例 - 优惠券
export const couponBusinessLogger = createBusinessLogger<ProfileEventNames>(
  'coupon',
  categoryNames,
);

// Business Logger 实例 - 心愿单
export const wishListBusinessLogger = createBusinessLogger<ProfileEventNames>(
  'wish_list',
  categoryNames,
);
